import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import StatisticsByCountryContentComponent from './StatisticsByCountryContent/StatisticsByCountryContent.container';
import { withRouter } from '../../RouterCompatibility.js';

const StatisticsByCountryPage = ({ location, t }) => {
    const staticNames = t?.reportPage || {};

    return (
        <div className="dashboard dashboard_consolidated-report">
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.titleByCountry}</h2>
                </div>
            </div>

            <StatisticsByCountryContentComponent
                location={location}
            />
        </div>
    );
};

StatisticsByCountryPage.propTypes = {
    location: PropTypes.object,
    t: PropTypes.object
};

StatisticsByCountryPage.defaultProps = {
    location: {},
    t: {}
};

export default withRouter(withTranslation(StatisticsByCountryPage));